export default __webpack_public_path__ + "assets/icons/icon-empty-box.3eac4391028ef570618a4e8ffa32d428.svg";